<template>
  <div>
    <header class="header">
      <h1>Pages</h1>
      <router-link class="button" :to="{ name: 'page-create' }">New</router-link>
    </header>

    <list-table :data="pages">
      <template slot="thead">
        <th>Name</th>
        <th></th>
      </template>

      <template slot-scope="props">
        <td>
          <router-link :to="{ name: 'page', params: { slug: props.instance.slug, section: props.instance.section } }">
            {{ props.instance.title }}
          </router-link>
        </td>
        <td width="100px">
          <remove-item-button apiUrl="pages" v-model="pages" :id="props.instance.id"></remove-item-button>
        </td>
      </template>
    </list-table>
  </div>
</template>

<script>
import ListTable from '@/components/ListTable'
import RemoveItemButton from '@/components/RemoveItemButton'
export default {
  data () {
    return {
      pages: []
    }
  },

  components: {
    ListTable,
    RemoveItemButton
  },

  mounted () {
    this.axios.get('pages')
      .then(res => {
        this.pages = res.data
      })
  }
}
</script>
